import React from "react";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export function CheckboxWithLabel({ label, nameAndId, handleCheck, checkboxStyles = null }) {
    return <FormGroup>
        <FormControlLabel sx={{width: 'fit-content'}} control={<Checkbox sx={checkboxStyles} />} label={label} onChange={handleCheck} name={nameAndId} />
    </FormGroup>
}